import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import { CustomText } from '../../../@shared/customText';
import Icon from '../../../@shared/icon';
import Picture from '../../../@shared/picture';
import { TEditorialImageProps } from '../../../@shared/picture/types/editorialImage.types';
import StyledLink from '../../../@shared/styledLink';
import { TstoriesCardContent } from '../../types/blogNews.types';

const storiesCardContent: FC<TstoriesCardContent> = (props) => {
  const { isEE, link, image, mobileImage, defaultCardImage, title, subtitle, cardHeadingTag } = props;

  const storiesCardLink = isEE ? (
    <StyledLink field={link} />
  ) : (
    <span className="link-with-arrow">
      <span>{link?.value?.text}</span>
      <Icon iconName="arrow-chevron-right" size={iconSize['dsk']} color="primary" />
    </span>
  );

  const editorialImageProps = () => {
    const imageProps: TEditorialImageProps = {};
    const desktopCardImage = image;
    const mobileCardImage = mobileImage;
    if (desktopCardImage?.value?.src || mobileCardImage?.value?.src) {
      imageProps['desktopImage'] = desktopCardImage;
      imageProps['mobileImage'] = mobileCardImage;
    } else {
      imageProps['desktopImage'] = defaultCardImage;
      imageProps['mobileImage'] = defaultCardImage;
    }
    imageProps['desktopTransformation'] = 'Size500';
    imageProps['mobileTransformation'] = 'Size300';
    return imageProps;
  };

  return (
    <>
      <Picture
        editorialImageProps={{
          ...editorialImageProps(),
          cssClassImageEl: 'stories-card__bg-image',
        }}
      />
      {!!(title?.value || subtitle?.value || link?.value?.href) && (
        <>
          <div className="stories-card__content">
            <CustomText tag={cardHeadingTag} field={title} className="stories-card__title" />
            <CustomText tag="div" field={subtitle} className="stories-card__description rich-text" />
            {!!(link?.value?.text && link?.value?.href) && <div className="stories-card__link">{storiesCardLink}</div>}
          </div>
        </>
      )}
    </>
  );
};

export default storiesCardContent;
